import type { PropsWithChildren } from "react";

import { Alert, type AlertRootProps } from "../../components";

export type BasicAlertProps = PropsWithChildren<{
  title: string;
  type?: AlertRootProps["type"];
  className?: string;
  onClose?: () => void;
}>;

const BasicAlert = ({ type = "primary", title, children, onClose, className }: BasicAlertProps) => {
  return (
    <Alert.Root type={type} orientation="horizontal" className={className}>
      <Alert.IconLayout title={title}>{typeof children === "string" ? <p>{children}</p> : children}</Alert.IconLayout>
      {onClose && <Alert.Close onClick={onClose} />}
    </Alert.Root>
  );
};

export default BasicAlert;
